/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看提现申请
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.ExtractApplyDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/extract/detail`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
